/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface MergeCustomerRecordsRequest
 */
export interface MergeCustomerRecordsRequest {
    /**
     * 
     * @type {number}
     * @memberof MergeCustomerRecordsRequest
     */
    sourceCustomerId?: number;
    /**
     * 
     * @type {number}
     * @memberof MergeCustomerRecordsRequest
     */
    targetCustomerId?: number;
    /**
     * 
     * @type {number}
     * @memberof MergeCustomerRecordsRequest
     */
    contactId?: number;
}

/**
 * Check if a given object implements the MergeCustomerRecordsRequest interface.
 */
export function instanceOfMergeCustomerRecordsRequest(value: object): boolean {
    return true;
}

export function MergeCustomerRecordsRequestFromJSON(json: any): MergeCustomerRecordsRequest {
    return MergeCustomerRecordsRequestFromJSONTyped(json, false);
}

export function MergeCustomerRecordsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MergeCustomerRecordsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'sourceCustomerId': json['sourceCustomerId'] == null ? undefined : json['sourceCustomerId'],
        'targetCustomerId': json['targetCustomerId'] == null ? undefined : json['targetCustomerId'],
        'contactId': json['contactId'] == null ? undefined : json['contactId'],
    };
}

export function MergeCustomerRecordsRequestToJSON(value?: MergeCustomerRecordsRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'sourceCustomerId': value['sourceCustomerId'],
        'targetCustomerId': value['targetCustomerId'],
        'contactId': value['contactId'],
    };
}

